import React from 'react';


export class ChartWahlbeteiligung extends React.Component {
	
	render() {
		console.log('pr', this.props.percentage)
		return (
			<div className="center">
				<svg width="100%" height="100%" viewBox="0 0 42 42" className="donut" role="img">
					<circle 
						strokeLinecap="round" 
						className="donut-ring" 
						cx="21" 
						cy="21" 
						r="15.91549430918954" 
						fill="transparent" 
						stroke="#bce0fd" 
						strokeWidth="4" 
						role="presentation">
					</circle>
					<circle 
						className="donut-segment" 
						cx="21" 
						cy="21" 
						r="15.91549430918954" 
						fill="transparent" 
						stroke="#2699fb" 
						strokeWidth="4" 
						strokeLinecap="round" 
						strokeDasharray={this.props.percentage ? this.props.percentage.toString() + " " + (100 - this.props.percentage).toString() : "0 100"} 
						strokeDashoffset="25">
					</circle>
					<g className="chart-text">
						<text x="50%" y="50%" className="chart-number">
							{this.props.percentage
								? this.props.percentage.toFixed(1) + '%'
								: '-'
							}
						</text>
					</g>

				</svg>
			</div>
		)
	}
}
